<div data-test="DUdSTKne" class="dropdown dropdown_bottom-middle dropdown_arrow">
  <div data-test="qCQQ4l2C" class="dropdown__wrap">
    <div data-test="u_FHTqER" class="dropdown__search">
      <input
        data-test="ZQHQwrQD"
        class="dropdown__input input input_xs"
        #searchInput
        placeholder="Search..."
        type="text"
      />
    </div>
    <ul
      data-test="yI7GqZ_-"
      class="dropdown__menu"
      *ngIf="{ places: foundPlaces$ | async | notNull } as data"
    >
      <li
        data-test="7LOrF_d6"
        class="dropdown__menu-item font-weight-medium"
        *ngFor="let place of data.places?.list; trackBy: trackControl"
        (click)="selectPlace($any(data.places?.type), place.originalItem)"
      >
        <a data-test="m9rikDWl" class="dropdown__menu-link">
          <div data-test="axTa8B80" class="icon">
            <svg
              data-test="QvC0o5ca"
              class="icon__icon-map-pin"
              width="9.63px"
              height="13.84px"
            >
              <use xlink:href="#icon-map-pin"></use>
            </svg>
          </div>
          <span data-test="3Uqb0W5x" class="text-dark">{{ place.name }}</span>
          <span data-test="Jq0Rcopi" class="text-light">{{ place.address }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
